import { LitElement, html, nothing } from "lit";
import { packageStyles } from "js/sharedStyles/package.js";

import { unsafeHTML } from "lit/directives/unsafe-html.js";

class WJPackage extends LitElement {
  static get properties() {
    return {
      packageElement: {
        type: Object,
        attribute: "data-package-element",
      },
      priceDisplay: {
        type: String,
        attribute: "data-price-display",
      },
      contractDetails: {
        type: Object,
        reflect: true,
      },
    };
  }
  static styles = [packageStyles];

  onDataFetchedTariff(e) {
    const packageData = e.detail.data;
    this.contractDetails = packageData.contractDetails;
  }

  getEnergyTypeFromUrl(url) {
    const match = url.match(/offers\/(.*?)\/info/);
    return match && match[1] ? match[1] : "";
  }

  getFormUrl(p) {
    const detailUrl = p.link.href;

    const energyTypeRegex = /offers\/(.*?)\/info/;
    const energyTypeMatch = detailUrl.match(energyTypeRegex);

    const queryRegex = /info\/(.*?)\/\d/;
    const queryMatch = detailUrl.match(queryRegex);

    let energyType = "";
    let query = "";

    if (energyTypeMatch && energyTypeMatch[1]) {
      energyType = energyTypeMatch[1];
    }

    if (queryMatch && queryMatch[1]) {
      query = queryMatch[1];
    }

    const tariffId = p.tariff.id;
    const params = Object.fromEntries(new URLSearchParams(window.location.search));

    let usage = params.usage || "0";
    let htUsage = params.highUsage || "0";
    let ntUsage = params.lowUsage || "0";
    let heatingType = params.heatingType || "";
    let meterType = params.meterType || "";

    const formattedCity = document.querySelector("#selectedAddress")?.value.replace("/", "-");
    const location = document.querySelector("#hiddenLocationInput")?.value;
    const postCode = document.querySelector("#postalCode")?.value;
    const hiddenUsageInput = document.querySelector("#hiddenUsageInput")?.value;
    const hiddenHighUsageInput = document.querySelector("#hiddenHighUsageInput")?.value;
    const hiddenLowUsageInput = document.querySelector("#hiddenLowUsageInput")?.value;
    const hiddenMeterType = document.querySelector("#hiddenMeterType")?.value;

    if (hiddenMeterType && hiddenMeterType !== meterType) {
      meterType = hiddenMeterType;
    }

    if (hiddenUsageInput && hiddenUsageInput !== usage) {
      usage = hiddenUsageInput;
    }

    if (hiddenHighUsageInput && hiddenHighUsageInput !== htUsage) {
      htUsage = hiddenHighUsageInput;
    }

    if (hiddenLowUsageInput && hiddenLowUsageInput !== ntUsage) {
      ntUsage = hiddenLowUsageInput;
    }

    const queryParams = {
      location,
      postCode,
      city: formattedCity,
      energyType,
      tariffId,
      query,
      usage,
    };

    queryParams.profile = (() => {
      switch (heatingType) {
        case "nightheat":
          return "HZ0-h";
        case "heatpump":
          return "HZ2-h";
        default:
          return "H0";
      }
    })();

    if (htUsage !== "0") {
      queryParams.htUsage = htUsage;
    }

    if (ntUsage !== "0") {
      queryParams.ntUsage = ntUsage;
    }

    if (meterType) {
      queryParams.meterType = meterType === "dual" ? "double" : "single";
    }

    const queryString = new URLSearchParams(queryParams).toString();

    return `/stromrechner/antrag?${queryString}`;
  }

  euroDisplay(amount) {
    if (isNaN(amount) && amount.indexOf(",") > -1) {
      amount = amount.replace(/\,/g, ".");
    }

    return unsafeHTML(parseFloat(amount).toFixed(2).replace(".", ",") + "&nbsp;&euro;");
  }

  render() {
    let p = this.packageElement;
    p.energyType = this.getEnergyTypeFromUrl(p.link.href);

    if (p.rank == 1) {
      // debugging the object
      //console.log(this.packageElement);
    }
    if (!this.packageElement) return html``;
    const encodedURI = encodeURI(p.link.href);
    const detailPostUrl = `${window.ortus.api}package/detail`;
    const detailPostData = {
      packageDetailsUri: encodedURI,
    };

    const reviewPercentage = p.provider.userRatings?.additonalCustomerRatings.averagePercent ? Math.ceil(p.provider.userRatings?.additonalCustomerRatings.averagePercent) : null;

    const reviewRating = parseFloat(reviewPercentage) / 10;
    const jsonUserRatings = JSON.stringify(p.provider.userRatings);

    return html`<div class="c-package">
      <div class="ph(!s) ph-(s)">${this.renderPackageHeader(p, this.priceDisplay)}</div>
      <bc-tabs class="c-package--tabs" exportparts="tab: tab, tab-selected: tab-selected" data-is-closable="true">
        <bc-tab data-tab-title="Preisdetails" tooltip="" class="c-package--tab">
          <wj-package-pricedetails cost=${JSON.stringify(p.cost)}></wj-package-pricedetails>
        </bc-tab>

        <bc-tab data-tab-title="Tarifdetails" data-is-async detailPostUrl=${detailPostUrl} detailPostData=${JSON.stringify(detailPostData)} @data-fetched=${this.onDataFetchedTariff} tooltip="Uitgebreidere informatie over de opbouw van de prijzen van dit pakket">
          <wj-package-tariff contractDetails=${JSON.stringify(this.contractDetails)}></wj-package-tariff>
        </bc-tab>
        ${reviewPercentage > 0
          ? html` <bc-tab ?hidden=${reviewPercentage == 0} data-tab-title="${`Kundenbewertung`}  ${reviewRating}">
              <wj-supplier-reviews data-user-ratings=${jsonUserRatings}></wj-supplier-reviews>
            </bc-tab>`
          : nothing}
      </bc-tabs>
    </div>`;
  }
  renderPackageHeader(p) {
    return html` <div class="c-package--header">
        <div class="c-package--position">${p.rank}</div>
        <div class="c-package--logo">
          <img src="${p.provider?.logoUrl}" />
        </div>

        <div class="c-package--summary">
          <h4 class="u-font-size-6(s) mb--">${p.tariff?.content?.text}</h4>
          <div class="c-package--tags">
            ${p.tariff.isEcoTariff == true
              ? html`
                  <span class="c-package--green u-font-size-6 mr-">
                    <span>${p.energyType === "gas" ? "Ökogas" : "Ökostrom"}</span>
                    <bc-tooltip data-trigger-style="dashed">${p.energyType === "gas" ? "Bei mit Ökogas gekennzeichneten Tarifen handelt es sich um CO2-kompensiertes Erdgas. Dabei wird das Kohlendioxid (CO2), das bei Verbrennung des Erdgases entsteht, durch den Erwerb und die Entwertung von Klimaschutzzertifkaten aus internationalen Klimaschutzprojekten ausgeglichen" : "Mit öko gekennzeichneter Strom kommt zu 100% aus erneuerbaren Energien."} </bc-tooltip>
                    <span> ${this.renderLeaf()} </span>
                  </span>
                `
              : nothing}
            ${p.remarks
              .filter((remark) => remark.content.text.includes("bonus"))
              .map(
                (remark) => html`
                  <div class="c-tag c-tag--green c-tag--border mb--">${unsafeHTML(remark.content.text.replace("zzgl.", "inkl."))}</div>
                  <bc-tooltip data-trigger-style="none">
                    <h6>${unsafeHTML(remark.content.tooltip.header)}</h6>
                    ${unsafeHTML(remark.content.tooltip.body)}
                  </bc-tooltip>
                `
              )}
          </div>
        </div>
        <div class="c-package--costs">
          <!-- Check - Get values dynamic -->
          <div class="c-package--costs-text">${this.priceDisplay === "month" ? "Ø-Monatspreis im 1. Jahr" : "Im 1. Jahr"}</div>
          <div class="c-package--costs-price c-spec">${this.priceDisplay === "month" ? this.euroDisplay(p.cost?.totalCost?.amount / 12) : this.euroDisplay(p.cost?.totalCost?.amount)}</div>
        </div>
      </div>

      <div class="c-package--savings-wrapper">
        ${p.cost?.savings?.amount > 20 ? html` <span class="c-package--savings">Sie sparen ${this.euroDisplay(p.cost?.savings?.amount)}</span> ` : nothing}
        <bc-tooltip data-trigger-style="dashed"> ${unsafeHTML(p.cost.savings.content.tooltip.body)} </bc-tooltip>
      </div>

      <div class="c-package--meta">
        <div class="c-package--meta-item">
          <div class="c-package--tags">
            ${p.remarks
              .filter((remark) => !includesBannedTags(remark.content.text))
              .map(
                (remark) => html`<div class="c-tag c-tag--blue c-tag--border mb--">${unsafeHTML(remark.content.text)}</div>

                  <bc-tooltip data-trigger-style="none">
                    <h6>${unsafeHTML(remark.content.tooltip.header)}</h6>
                    ${unsafeHTML(remark.content.tooltip.body)}
                  </bc-tooltip>`
              )}
          </div>
        </div>
        <div class="c-package--meta-item">${p.link && p.link.rel == "offerInfo" ? html` <a class="c-button c-button--accent mt-- ph+" href="${this.getFormUrl(p)}">Anmelden</a>` : nothing}</div>
      </div>`;
  }
  renderLeaf() {
    return html` <svg width="15" height="20" viewBox="0 0 15 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.18 0s-1.645 1.596-3.424 2.24c-13.179 4.767-7.621 14.056-7.44 14.087 0 0 .74-1.287 1.738-2.021 6.334-4.657 7.622-10.017 7.622-10.017s-1.422 6.45-7.057 10.463C2.374 15.638 1.53 17.82 1.174 20c0 0 .883-.356 1.262-.453.148-.966.457-1.89.98-2.716 7.877.938 10.457-5.409 10.794-7.622C15.005 3.982 12.18 0 12.18 0z" fill="#008500" class="u-svg-fill" />
    </svg>`;
  }
}

const includesBannedTags = (text) => {
  const bannedTags = ["erstlaufzeit", "onlinetarif", "gültig seit", "nicht enthalten", "bonus"];
  const lowerText = text.toLowerCase();
  return bannedTags.some((tag) => lowerText.includes(tag));
};

const initWJPackage = () => {
  customElements.define("wj-package", WJPackage);
};
export { initWJPackage };
